var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 3.63 9 7.26 9 11 C6.03 11 3.06 11 0 11 C0 7.37 0 3.74 0 0 Z M2 2 C2 4.31 2 6.62 2 9 C3.65 9 5.3 9 7 9 C7 6.69 7 4.38 7 2 C5.35 2 3.7 2 2 2 Z ",
    fill: "#000000",
    transform: "translate(13,11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 3.63 9 7.26 9 11 C6.03 11 3.06 11 0 11 C0 7.37 0 3.74 0 0 Z M2 2 C2 4.31 2 6.62 2 9 C3.65 9 5.3 9 7 9 C7 6.69 7 4.38 7 2 C5.35 2 3.7 2 2 2 Z ",
    fill: "#000000",
    transform: "translate(2,2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 2.31 9 4.62 9 7 C6.03 7 3.06 7 0 7 C0 4.69 0 2.38 0 0 Z M2 2 C2 2.99 2 3.98 2 5 C3.65 5 5.3 5 7 5 C7 4.01 7 3.02 7 2 C5.35 2 3.7 2 2 2 Z ",
    fill: "#000000",
    transform: "translate(2,15)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 2.31 9 4.62 9 7 C6.03 7 3.06 7 0 7 C0 4.69 0 2.38 0 0 Z M2 2 C2 2.99 2 3.98 2 5 C3.65 5 5.3 5 7 5 C7 4.01 7 3.02 7 2 C5.35 2 3.7 2 2 2 Z ",
    fill: "#000000",
    transform: "translate(13,2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.3fdb39b9e7f78ba94aae4da9931bd308.svg";
export { ForwardRef as ReactComponent };